import React from 'react'

const Showcase = () => {
    return (
      <section className="py-5 showcase">
        <div className="container py-2 text-center">
          <h4 className="font-heading m-0">Take the next step</h4>
          <p className="font-normal">
            Finding the right tech talent can be difficult and time consuming,
           <br /> let's make it easier and efficient for you
          </p>
          <div className="py-2 d-flex justify-content-center">
            <button className="mr-1 font-normal primary-btn purple-btn large-btn">
              Build your product{" "}
              <i className="fas fa-long-arrow-alt-right vertical-middle pl-50"></i>
            </button>
            <button className="font-normal secondary-btn secondary-btn2 text-black large-btn">
              Hire a Developer{" "}
              <i className="fas fa-long-arrow-alt-right vertical-middle pl-50"></i>
            </button>
          </div>
        </div>
      </section>
    );
}

export default Showcase
